// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feed-card-outer-wrapper {
    height: 430px;
    width: 355px;
    position: relative;
    border-radius: 1rem;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    opacity: 1;
    cursor: unset;
    margin-top: 1px;
    margin-bottom: 30px;
}

.feed-card-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
}

.feed-image {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    background-position: center;
    border-radius: 1rem;
    z-index: 1;
}

.feed-image-spinner {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0,0,0,0.2); /* optional overlay */
    z-index: 1;
}

.spinner {
    width: 24px;
    height: 24px;
    border: 3px solid #fff;
    border-top: 3px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.image-progress {
    position: absolute;
    top: 0.3rem;
    right: 0.5rem;
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    min-width: 3.125rem;
    cursor: pointer;
    padding: 0.9375rem;
}

.image-counter{
    font-size: 0.5625rem;
    letter-spacing: 0.03125rem;
    text-shadow: rgba(0, 0, 0, 0.5) 0px 0.125rem 0.25rem;
    opacity: 0.82;
    margin-right: 0.625rem;
    transform: translateY(-0.1875rem);
    color: rgb(255, 255, 255);
}

.image-icon {
    line-height: 0;
    filter: drop-shadow(rgba(0, 0, 0, 0.25) 0px 0.125rem 0.25rem);
}

.feed-card {
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 2;
}

.feed-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.7) 100%);
    border-radius: 1rem;
    z-index: 2;
}

.feed-header {
    padding: 1.25rem;
    position: relative;
    z-index: 3;
    color: white;
}

.tag-bubble {
    border-radius: 0.25rem;
    display: inline-block;
    padding: 0.25rem 0.625rem;
    text-transform: uppercase;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.5625rem;
    line-height: 1;
    font-weight: 400;
    -webkit-user-select: none;
            user-select: none;
    max-width: 80%;
    overflow: hidden;
    margin-bottom: 0.5rem;
}

.card-title {
    margin: 0.75rem 0 0;
    font-size: 1.25rem;
    font-weight: bold;
    text-shadow: 0 0 4px rgba(0, 0, 0, 0.75);
    -webkit-user-select: text;
            user-select: text;
}

.hours-and-view {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.75rem;
    color: white;
    font-size: 0.75rem;
}

.view-badge {
    display: inline-block;
    background: #ccc;
    color: #007fff;
    font-size: 0.625rem;
    text-transform: uppercase;
    border-radius: 0.675rem;
    padding: 0.3125rem 0.8125rem 0.21875rem;
    cursor: pointer;
}

.nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 2rem;
    color: white;
    z-index: 3;
    cursor: pointer;
    padding: 0 0.5rem;
}

.nav.left {
    left: 0;
}

.nav.right {
    right: 0;
}

.feed-footer {
    z-index: 3;
    position: relative;
    font-size: 0.75rem;
    color: rgb(65, 65, 65);
    background: rgb(255, 255, 255);
    padding: 0.9375rem 1.25rem;
}

.saves {
    font-weight: bold;
    margin-bottom: 0.25rem;
}

.footer-description {
    margin-bottom: 0.5rem;
    word-break: break-word;
    font-size: 0.875rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    max-height: 2.1rem;
}

.footer-actions {
    display: flex;
    gap: 0.5rem;
}

.footer-actions button {
    background: transparent;
    border: none;
    color: white;
    cursor: pointer;
    font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/FeedItemCard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,UAAU;IACV,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B,EAAE,qBAAqB;IAClD,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,8CAA8C;IAC9C,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,aAAa;IAEb,qBAAqB;IAErB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,0BAA0B;IAC1B,oDAAoD;IACpD,aAAa;IACb,sBAAsB;IACtB,iCAAiC;IACjC,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,6DAA6D;AACjE;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,qFAAqF;IACrF,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,wCAAwC;IACxC,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;IACvB,uCAAuC;IACvC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,YAAY;IACZ,UAAU;IACV,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;AACnB","sourcesContent":[".feed-card-outer-wrapper {\n    height: 430px;\n    width: 355px;\n    position: relative;\n    border-radius: 1rem;\n    overflow: hidden;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n    opacity: 1;\n    cursor: unset;\n    margin-top: 1px;\n    margin-bottom: 30px;\n}\n\n.feed-card-wrapper {\n    position: relative;\n    height: 100%;\n    width: 100%;\n}\n\n.feed-image {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-size: cover;\n    background-position: center;\n    border-radius: 1rem;\n    z-index: 1;\n}\n\n.feed-image-spinner {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0,0,0,0.2); /* optional overlay */\n    z-index: 1;\n}\n\n.spinner {\n    width: 24px;\n    height: 24px;\n    border: 3px solid #fff;\n    border-top: 3px solid rgba(255, 255, 255, 0.3);\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.image-progress {\n    position: absolute;\n    top: 0.3rem;\n    right: 0.5rem;\n    display: flex;\n    -webkit-box-align: baseline;\n    align-items: baseline;\n    -webkit-box-pack: end;\n    justify-content: flex-end;\n    min-width: 3.125rem;\n    cursor: pointer;\n    padding: 0.9375rem;\n}\n\n.image-counter{\n    font-size: 0.5625rem;\n    letter-spacing: 0.03125rem;\n    text-shadow: rgba(0, 0, 0, 0.5) 0px 0.125rem 0.25rem;\n    opacity: 0.82;\n    margin-right: 0.625rem;\n    transform: translateY(-0.1875rem);\n    color: rgb(255, 255, 255);\n}\n\n.image-icon {\n    line-height: 0;\n    filter: drop-shadow(rgba(0, 0, 0, 0.25) 0px 0.125rem 0.25rem);\n}\n\n.feed-card {\n    position: relative;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    z-index: 2;\n}\n\n.feed-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.7) 100%);\n    border-radius: 1rem;\n    z-index: 2;\n}\n\n.feed-header {\n    padding: 1.25rem;\n    position: relative;\n    z-index: 3;\n    color: white;\n}\n\n.tag-bubble {\n    border-radius: 0.25rem;\n    display: inline-block;\n    padding: 0.25rem 0.625rem;\n    text-transform: uppercase;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 0.5625rem;\n    line-height: 1;\n    font-weight: 400;\n    user-select: none;\n    max-width: 80%;\n    overflow: hidden;\n    margin-bottom: 0.5rem;\n}\n\n.card-title {\n    margin: 0.75rem 0 0;\n    font-size: 1.25rem;\n    font-weight: bold;\n    text-shadow: 0 0 4px rgba(0, 0, 0, 0.75);\n    user-select: text;\n}\n\n.hours-and-view {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 0.75rem;\n    color: white;\n    font-size: 0.75rem;\n}\n\n.view-badge {\n    display: inline-block;\n    background: #ccc;\n    color: #007fff;\n    font-size: 0.625rem;\n    text-transform: uppercase;\n    border-radius: 0.675rem;\n    padding: 0.3125rem 0.8125rem 0.21875rem;\n    cursor: pointer;\n}\n\n.nav {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 2rem;\n    color: white;\n    z-index: 3;\n    cursor: pointer;\n    padding: 0 0.5rem;\n}\n\n.nav.left {\n    left: 0;\n}\n\n.nav.right {\n    right: 0;\n}\n\n.feed-footer {\n    z-index: 3;\n    position: relative;\n    font-size: 0.75rem;\n    color: rgb(65, 65, 65);\n    background: rgb(255, 255, 255);\n    padding: 0.9375rem 1.25rem;\n}\n\n.saves {\n    font-weight: bold;\n    margin-bottom: 0.25rem;\n}\n\n.footer-description {\n    margin-bottom: 0.5rem;\n    word-break: break-word;\n    font-size: 0.875rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    max-height: 2.1rem;\n}\n\n.footer-actions {\n    display: flex;\n    gap: 0.5rem;\n}\n\n.footer-actions button {\n    background: transparent;\n    border: none;\n    color: white;\n    cursor: pointer;\n    font-size: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
